import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './topbrandssecweb.css';

export default class TopBrandsSectionWeb extends Component {
    render() {
        return (
            <>
            <div className="top-bbrands-com-webversion-main-sectionx">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="topp-brands-wexv-dot-main-sec-bboxx-web-version">
                                <div className="top-brannsxds-dott-ccm-dealmmnnff-bb-web-verrsn">
                                    <p><span><img src={require('../../../assets/top-brands-web-icon.svg')} alt="orponbd online shop"/></span> Top Brands</p>
                                    <Link to="/top-brands-all-brands"><span>View More <i className="fa fa-angle-right"></i></span></Link>
                                </div>

                                <div className="row top-brandds-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/brand-xiaomi">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-1.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-11.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-2.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-22.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-3.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-33.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-4.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-44.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-5.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-55.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="topp-brandds-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/top-brand-6.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-txt mx-auto">
                                                    <p>1500 Likes</p>
                                                </div>
                                                <div className="top-brandd-ddot-cmm-snnggl-prodct-web-vvesnn-big-img">
                                                    <img src={require('../../../assets/top-brand-66.png')} alt="orponbd online shop"/>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}
